// import React, { useState, useEffect } from "react";
// import "./AdvertisementForm.css";

// const AdvertisementForm = ({ onSubmit }) => {
//   const [type, setType] = useState("");
//   const [carouselImages, setCarouselImages] = useState([]);
//   const [showcaseImages, setShowcaseImages] = useState({});
//   const [videoFile, setVideoFile] = useState(null);
//   const [textInputs, setTextInputs] = useState([]);
//   const [advertisements, setAdvertisements] = useState([]); // State for fetched advertisements

//   // Fetch advertisements when the component mounts
//   useEffect(() => {
//     const fetchAdvertisements = async () => {
//       try {
//         const response = await fetch("https://spinelleapi.emedha.in/admin/advertise/get/advertise");
//         const data = await response.json();
//         if (data.data) {
//           setAdvertisements(data.data); // Store advertisements in state
//         }
//       } catch (error) {
//         console.error("Error fetching advertisements:", error);
//       }
//     };
//     fetchAdvertisements();
//   }, []);

//   // Handle type change
//   const handleTypeChange = (e) => {
//     const selected = e.target.value;
//     setType(selected);
//     setTextInputs([]);
//     setCarouselImages([]);
//     setShowcaseImages({});
//     setVideoFile(null);
//   };

//   // Handle Carousel Upload
//   const handleCarouselUpload = (e) => {
//     const files = Array.from(e.target.files);
//     if (files.length >= 3) {
//       const imagesWithText = files.slice(0, 3).map((file) => ({
//         file,
//         title: "",
//         subtitle: "",
//         highlight: "",
//       }));
//       setCarouselImages(imagesWithText);
//     } else {
//       alert("Please upload at least 3 images for the carousel.");
//     }
//   };

//   const handleCarouselTextChange = (index, field, value) => {
//     const updated = [...carouselImages];
//     updated[index][field] = value;
//     setCarouselImages(updated);
//   };

//   const handleShowcaseUpload = (e, position) => {
//     setShowcaseImages({ ...showcaseImages, [position]: e.target.files[0] });
//   };

//   const handleTextInputChange = (field, value) => {
//     setTextInputs({ ...textInputs, [field]: value });
//   };

//   // Handle Advertisement Form Submission
// const handleSubmit = async () => {
//   const formData = new FormData();
//   formData.append("type", type);

//   // Carousel Images for Hero Carousel
//   if (type === "Hero Carousel") {
//     carouselImages.forEach((img, i) => {
//       formData.append("carousel_images", img.file);
//       formData.append(`carousel_title_${i}`, img.title);
//       formData.append(`carousel_subtitle_${i}`, img.subtitle);
//       formData.append(`carousel_highlight_${i}`, img.highlight);
//     });
//   }

//   // Showcase Cards
//   if (type === "Showcase Cards") {
//     formData.append("left_large", showcaseImages.left_large);
//     formData.append("right_top", showcaseImages.right_top);
//     formData.append("right_bottom", showcaseImages.right_bottom);
//   }

//   // Offer or Video Banner
//   if (type === "Offer Banner" || type === "Video Banner") {
//     if (videoFile) {
//       formData.append("video", videoFile);
//     } else {
//       alert("Video file is required.");
//       return;
//     }

//     // Ensure heading and subtitle are included
//     const heading = textInputs.heading || "";
//     const subtitle = textInputs.subtitle || "";

//     // Append heading and subtitle
//     formData.append("heading", heading);
//     formData.append("subtitle", subtitle);
//   }

//   try {
//     const response = await fetch("https://spinelleapi.emedha.in/admin/advertise/create", {
//       method: "POST",
//       body: formData,
//     });
//     const data = await response.json();
//     if (data.error) {
//       alert(data.error);
//     } else {
//       alert(data.message);
//       // Refresh the advertisements list after adding a new ad
//       fetchAdvertisements();
//     }
//   } catch (error) {
//     console.error("Error:", error);
//     alert("An error occurred while submitting the form.");
//   }
// };


//   // Handle Advertisement Deletion
//   const handleDelete = async (id) => {
//     const confirmDelete = window.confirm("Are you sure you want to delete this advertisement?");
//     if (confirmDelete) {
//       try {
//         const response = await fetch(`https://spinelleapi.emedha.in/admin/advertise/delete/${id}`, {
//           method: "DELETE",
//         });
//         const data = await response.json();
//         if (data.message) {
//           alert(data.message);
//           // Refresh the advertisements list after deleting
//           fetchAdvertisements();
//         } else {
//           alert(data.error);
//         }
//       } catch (error) {
//         console.error("Error deleting advertisement:", error);
//         alert("An error occurred while deleting the advertisement.");
//       }
//     }
//   };

//   // Fetch advertisements after submitting or deleting
//   const fetchAdvertisements = async () => {
//     try {
//       const response = await fetch("https://spinelleapi.emedha.in/admin/advertiseget/advertise");
//       const data = await response.json();
//       if (data.data) {
//         setAdvertisements(data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching advertisements:", error);
//     }
//   };

//   return (
//     <div className="advertisement-form">
//       <h2>Create Advertisement</h2>
//       {/* Advertisement Form */}
//       <div className="form-group">
//         <label>Advertisement Type</label>
//         <select onChange={handleTypeChange}>
//           <option value="">Select</option>
//           <option value="Hero Carousel">Hero Carousel</option>
//           <option value="Showcase Cards">Showcase Cards</option>
//           <option value="Offer Banner">Offer Banner</option>
//           <option value="Video Banner">Video Banner</option>
//         </select>
//       </div>

//       {/* Type-specific UI */}
//       {type === "Hero Carousel" && (
//         <div className="carousel-section">
//           <label>Upload Carousel Images (Minimum 3 images)</label>
//           <input type="file" multiple accept="image/*" onChange={handleCarouselUpload} />
//           {carouselImages.length > 0 &&
//             carouselImages.map((img, index) => (
//               <div className="carousel-entry" key={index}>
//                 <span>{img.file.name}</span>
//                 <input
//                   type="text"
//                   placeholder="Title"
//                   value={img.title}
//                   onChange={(e) => handleCarouselTextChange(index, "title", e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   placeholder="Subtitle"
//                   value={img.subtitle}
//                   onChange={(e) => handleCarouselTextChange(index, "subtitle", e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   placeholder="Highlight"
//                   value={img.highlight}
//                   onChange={(e) => handleCarouselTextChange(index, "highlight", e.target.value)}
//                 />
//               </div>
//             ))}
//         </div>
//       )}

//       {type === "Showcase Cards" && (
//         <div className="showcase-section">
//           <label>Left Large Image</label>
//           <input type="file" accept="image/*" onChange={(e) => handleShowcaseUpload(e, "left_large")} />
//           <label>Right Top Image</label>
//           <input type="file" accept="image/*" onChange={(e) => handleShowcaseUpload(e, "right_top")} />
//           <label>Right Bottom Image</label>
//           <input type="file" accept="image/*" onChange={(e) => handleShowcaseUpload(e, "right_bottom")} />
//         </div>
//       )}

//       {(type === "Offer Banner" || type === "Video Banner") && (
//         <div className="video-section">
//           <label>Upload Video</label>
//           <input type="file" accept="video/*" onChange={(e) => setVideoFile(e.target.files[0])} />
//           <input
//             type="text"
//             placeholder="Heading"
//             onChange={(e) => handleTextInputChange("heading", e.target.value)}
//           />
//           <input
//             type="text"
//             placeholder="Subtitle"
//             onChange={(e) => handleTextInputChange("subtitle", e.target.value)}
//           />
//         </div>
//       )}

//       <button className="submit-btn" onClick={handleSubmit}>
//         Submit
//       </button>

//       {/* Advertisements List */}
//       <h3>Existing Advertisements</h3>
// <div className="advertisements-list">
//   {advertisements.length > 0 ? (
//     advertisements.map((ad) => (
//       <div className="advertisement-card" key={ad.id}>
//         <h4>{ad.type}</h4>
        
//         {/* Hero Carousel */}
//         {ad.type === "Hero Carousel" && (
//           <div className="carousel-display">
//             <div className="carousel-images">
//               {ad.carousel_images.map((image, index) => (
//                 <div className="carousel-image" key={index}>
//                   <img src={image} alt={`Carousel ${index + 1}`} />
//                   <div className="carousel-text">
//                     <h5>{ad.carousel_titles[index]}</h5>
//                     <p>{ad.carousel_subtitles[index]}</p>
//                     <p className="highlight">{ad.carousel_highlights[index]}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Showcase Cards */}
//         {ad.type === "Showcase Cards" && (
//           <div className="showcase-cards">
//             <div className="showcase-card">
//               <img src={ad.left_large} alt="Left Large" />
//               <p>Left Large Image</p>
//             </div>
//             <div className="showcase-card">
//               <img src={ad.right_top} alt="Right Top" />
//               <p>Right Top Image</p>
//             </div>
//             <div className="showcase-card">
//               <img src={ad.right_bottom} alt="Right Bottom" />
//               <p>Right Bottom Image</p>
//             </div>
//           </div>
//         )}

//         {/* Offer Banner */}
//         {ad.type === "Offer Banner" && ad.video && (
//           <div className="offer-video-banner">
//             <video width="100%" controls>
//               <source src={ad.video} type="video/mp4" />
//               Your browser does not support the video tag.
//             </video>
//             <div className="offer-details">
//               <h5>{ad.heading}</h5>
//               <p>{ad.subtitle}</p>
//             </div>
//           </div>
//         )}

//         {/* Video Banner */}
//         {ad.type === "Video Banner" && ad.video && (
//           <div className="video-banner">
//             <video width="100%" controls>
//               <source src={ad.video} type="video/mp4" />
//               Your browser does not support the video tag.
//             </video>
//             <div className="video-details">
//               <h5>{ad.heading}</h5>
//               <p>{ad.subtitle}</p>
//             </div>
//           </div>
//         )}

//         <button onClick={() => handleDelete(ad.id)} className="delete-btn">
//           Delete
//         </button>
//       </div>
//     ))
//   ) : (
//     <p>No advertisements found.</p>
//   )}
// </div>

//     </div>
//   );
// };

// export default AdvertisementForm;


import React, { useState, useEffect } from "react";
import "./AdvertisementForm.css";

const AdvertisementForm = ({ onSubmit }) => {
  const [type, setType] = useState("");  // The selected type for the ad
  const [carouselImages, setCarouselImages] = useState([]);
  const [showcaseImages, setShowcaseImages] = useState({});
  const [videoFile, setVideoFile] = useState(null);
  const [textInputs, setTextInputs] = useState([]);
  const [advertisements, setAdvertisements] = useState([]);

  // Fetch advertisements when the component mounts
  useEffect(() => {
    const fetchAdvertisements = async () => {
      try {
        const response = await fetch("https://spinelleapi.emedha.in/admin/advertise/get/advertise");
        const data = await response.json();
        if (data.data) {
          setAdvertisements(data.data); // Store advertisements in state
        }
      } catch (error) {
        console.error("Error fetching advertisements:", error);
      }
    };
    fetchAdvertisements();
  }, []);

  // Handle type change
  const handleTypeChange = (e) => {
    const selected = e.target.value;
    setType(selected);
    setCarouselImages([]);
    setShowcaseImages({});
    setVideoFile(null);
    setTextInputs([]);
  };

  // Handle Carousel Upload
  const handleCarouselUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length >= 2) {
      const imagesWithText = files.slice(0, 2).map((file) => ({
        file,
        title: "",
        subtitle: "",
        highlight: "",
      }));
      setCarouselImages(imagesWithText);
    } else {
      alert("Please upload at least 2 images for the carousel.");
    }
  };

  const handleCarouselTextChange = (index, field, value) => {
    const updated = [...carouselImages];
    updated[index][field] = value;
    setCarouselImages(updated);
  };

  const handleShowcaseUpload = (e, position) => {
    setShowcaseImages({ ...showcaseImages, [position]: e.target.files[0] });
  };

  const handleTextInputChange = (field, value) => {
    setTextInputs({ ...textInputs, [field]: value });
  };

  // Handle Advertisement Form Submission
  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("type", type);

    // Carousel Images for Hero Carousel
    if (type === "Hero Carousel") {
      carouselImages.forEach((img, i) => {
        formData.append("carousel_images", img.file);
        formData.append(`carousel_title_${i}`, img.title);
        formData.append(`carousel_subtitle_${i}`, img.subtitle);
        formData.append(`carousel_highlight_${i}`, img.highlight);
      });
    }

    // Showcase Cards
    if (type === "Showcase Cards") {
      formData.append("left_large", showcaseImages.left_large);
      formData.append("right_top", showcaseImages.right_top);
      formData.append("right_bottom", showcaseImages.right_bottom);
    }

    // Offer or Video Banner
    if (type === "Offer Banner" || type === "Video Banner") {
      if (videoFile) {
        formData.append("video", videoFile);
      } else {
        alert("Video file is required.");
        return;
      }

      // Ensure heading and subtitle are included
      const heading = textInputs.heading || "";
      const subtitle = textInputs.subtitle || "";

      // Append heading and subtitle
      formData.append("heading", heading);
      formData.append("subtitle", subtitle);
    }

    try {
      const response = await fetch("https://spinelleapi.emedha.in/admin/advertise/create", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.error) {
        alert(data.error);
      } else {
        alert(data.message);
        // Refresh the advertisements list after adding a new ad
        fetchAdvertisements();
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while submitting the form.");
    }
  };


    const fetchAdvertisements = async () => {
    try {
      const response = await fetch("https://spinelleapi.emedha.in/admin/advertise/get/advertise");
      const data = await response.json();
      if (data.data) {
        setAdvertisements(data.data);
      }
    } catch (error) {
      console.error("Error fetching advertisements:", error);
    }
  };

  // Handle Advertisement Deletion
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this advertisement?");
    if (confirmDelete) {
      try {
        const response = await fetch(`https://spinelleapi.emedha.in/admin/advertise/delete/${id}`, {
          method: "DELETE",
        });
        const data = await response.json();
        if (data.message) {
          alert(data.message);
          // Refresh the advertisements list after deleting
          fetchAdvertisements();
        } else {
          alert(data.error);
        }
      } catch (error) {
        console.error("Error deleting advertisement:", error);
        alert("An error occurred while deleting the advertisement.");
      }
    }
  };

  // Filter advertisements based on the selected type
  const filteredAdvertisements = advertisements.filter((ad) => ad.type === type || type === "");

  return (
    <div className="advertisement-form">
      <h2>Create Advertisement</h2>
      {/* Advertisement Type Selection */}
      <div className="form-group">
        <label>Advertisement Type</label>
        <select onChange={handleTypeChange} value={type}>
          <option value="">Select</option>
          <option value="Hero Carousel">Hero Carousel</option>
          <option value="Showcase Cards">Showcase Cards</option>
          <option value="Offer Banner">Offer Banner</option>
          <option value="Video Banner">Video Banner</option>
        </select>
      </div>

      {/* Type-specific UI */}
      {type === "Hero Carousel" && (
        <div className="carousel-section">
          <label>Upload Carousel Images (Minimum 2 images)</label>
          <input type="file" multiple accept="image/*" onChange={handleCarouselUpload} />
          {carouselImages.length > 0 &&
            carouselImages.map((img, index) => (
              <div className="carousel-entry" key={index}>
                <span>{img.file.name}</span>
                <input
                  type="text"
                  placeholder="Title"
                  value={img.title}
                  onChange={(e) => handleCarouselTextChange(index, "title", e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Subtitle"
                  value={img.subtitle}
                  onChange={(e) => handleCarouselTextChange(index, "subtitle", e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Highlight"
                  value={img.highlight}
                  onChange={(e) => handleCarouselTextChange(index, "highlight", e.target.value)}
                />
              </div>
            ))}
        </div>
      )}

      {type === "Showcase Cards" && (
        <div className="showcase-section">
          <label>Left Large Image</label>
          <input type="file" accept="image/*" onChange={(e) => handleShowcaseUpload(e, "left_large")} />
          <label>Right Top Image</label>
          <input type="file" accept="image/*" onChange={(e) => handleShowcaseUpload(e, "right_top")} />
          <label>Right Bottom Image</label>
          <input type="file" accept="image/*" onChange={(e) => handleShowcaseUpload(e, "right_bottom")} />
        </div>
      )}

      {(type === "Offer Banner" || type === "Video Banner") && (
        <div className="video-section">
          <label>Upload Video</label>
          <input type="file" accept="video/*" onChange={(e) => setVideoFile(e.target.files[0])} />
          <input
            type="text"
            placeholder="Heading"
            onChange={(e) => handleTextInputChange("heading", e.target.value)}
          />
          <input
            type="text"
            placeholder="Subtitle"
            onChange={(e) => handleTextInputChange("subtitle", e.target.value)}
          />
        </div>
      )}

      <button className="submit-btn" onClick={handleSubmit}>
        Submit
      </button>

      {/* Filtered Advertisements List */}
      <h3>Existing Advertisements</h3>
      <div className="advertisements-list">
        {filteredAdvertisements.length > 0 ? (
          filteredAdvertisements.map((ad) => (
            <div className="advertisement-card" key={ad.id}>
              <h4>{ad.type}</h4>

              {/* Hero Carousel */}
              {ad.type === "Hero Carousel" && (
                <div className="carousel-display">
                  <div className="carousel-images">
                    {ad.carousel_images.map((image, index) => (
                      <div className="carousel-image" key={index}>
                        <img src={image} alt={`Carousel ${index + 1}`} />
                        <div className="carousel-text">
                          <h5>{ad.carousel_titles[index]}</h5>
                          <p>{ad.carousel_subtitles[index]}</p>
                          <p className="highlight">{ad.carousel_highlights[index]}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Showcase Cards */}
              {ad.type === "Showcase Cards" && (
                <div className="showcase-cards">
                  <div className="showcase-card">
                    <img src={ad.left_large} alt="Left Large" />
                    <p>Left Large Image</p>
                  </div>
                  <div className="showcase-card">
                    <img src={ad.right_top} alt="Right Top" />
                    <p>Right Top Image</p>
                  </div>
                  <div className="showcase-card">
                    <img src={ad.right_bottom} alt="Right Bottom" />
                    <p>Right Bottom Image</p>
                  </div>
                </div>
              )}

              {/* Offer Banner */}
              {ad.type === "Offer Banner" && ad.video && (
                <div className="offer-video-banner">
                  <video width="100%" controls>
                    <source src={ad.video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <div className="offer-details">
                    <h5>{ad.heading}</h5>
                    <p>{ad.subtitle}</p>
                  </div>
                </div>
              )}

              {/* Video Banner */}
              {ad.type === "Video Banner" && ad.video && (
                <div className="video-banner">
                  <video width="100%" controls>
                    <source src={ad.video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <div className="video-details">
                    <h5>{ad.heading}</h5>
                    <p>{ad.subtitle}</p>
                  </div>
                </div>
              )}

              <button onClick={() => handleDelete(ad.id)} className="delete-btn">
                Delete
              </button>
            </div>
          ))
        ) : (
          <p>No advertisements found.</p>
        )}
      </div>
    </div>
  );
};

export default AdvertisementForm;
